import { ExecutionEnvironment } from '../enum/execution-environment.enum';
import { StringUtil } from './string-util';

export class ApiUrlUtil {
  public static getFormattedUrl(): string {
    const executionEnvironment = this.getExecutionEnvironment();
    switch (executionEnvironment) {
      case ExecutionEnvironment.development:
        return `${StringUtil.format(
          'https://{0}.dev.satelitti.com.br/rest/signer',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.homologation:
        return `${StringUtil.format(
          'https://{0}.hom.satelitti.com.br/rest/signer',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.production:
        return `${StringUtil.format(
          'https://{0}.satelitti.com.br/rest/signer',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.localhost:
        return 'http://127.0.0.1:59379/rest/signer';
      default:
        throw new Error(
          `URL não tratada para o ambiente de execução '${executionEnvironment}'`
        );
    }
  }

  public static getFormattedSuiteUrl(): string {
    const executionEnvironment = this.getExecutionEnvironment();
    switch (executionEnvironment) {
      case ExecutionEnvironment.development:
        return `${StringUtil.format(
          'https://{0}.dev.satelitti.com.br/rest/suite-auth',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.homologation:
        return `${StringUtil.format(
          'https://{0}.hom.satelitti.com.br/rest/suite-auth',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.production:
        return `${StringUtil.format(
          'https://{0}.satelitti.com.br/rest/suite-auth',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.localhost:
        return 'http://127.0.0.1:5167/rest/suite-auth';
      default:
        throw new Error(
          `URL não tratada para o ambiente de execução '${executionEnvironment}'`
        );
    }
  }

  public static getSignerUrlToRedirect(): string{
    const executionEnvironment = this.getExecutionEnvironment();
    switch (executionEnvironment) {
      case ExecutionEnvironment.development:
        return `${StringUtil.format(
          'https://{0}.dev.satelitti.com.br/signer',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.homologation:
        return `${StringUtil.format(
          'https://{0}.hom.satelitti.com.br/signer',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.production:
        return `${StringUtil.format(
          'https://{0}.satelitti.com.br/signer',
          this.getTenant()
        )}`;
      case ExecutionEnvironment.localhost:
        return 'http://127.0.0.1:59379/signer';
      default:
        throw new Error(
          `URL não tratada para o ambiente de execução '${executionEnvironment}'`
        );
    }
  }

  public static disableGeolocation(): boolean {
    const executionEnvironment = this.getExecutionEnvironment();
    switch (executionEnvironment) {
      case ExecutionEnvironment.homologation:
      case ExecutionEnvironment.development:
        return true;
      default:
        return false;
    }
  }

  public static recaptcha(): string {
    const executionEnvironment = this.getExecutionEnvironment();
    switch (executionEnvironment) {
      case ExecutionEnvironment.development:
        return '6LeVt0gaAAAAAGw_XEvJEET27oCCGnt6F2kJYLps';
      case ExecutionEnvironment.homologation:
        return '6Ld6_jEaAAAAAFp2Kx4x4BNrh2XFKCOUDxYEfzM5';
      case ExecutionEnvironment.production:
        return '6Lc5uUgaAAAAAL2ItH_iSfwL-IxGNtU9fXnKfomd';
      default:
        return '6Ld6_jEaAAAAAFp2Kx4x4BNrh2XFKCOUDxYEfzM5';
    }
  }

  public static googleAnalytics4Code(): string {
    const executionEnvironment = this.getExecutionEnvironment();
    switch (executionEnvironment) {
      case ExecutionEnvironment.production:
        return 'G-CTB4LZ998E';
      default:
        return 'G-J5VF41LQYB';
    }
  }

  private static getTenant(): string {
    return location.hostname.split('.')[0];
  }

  public static goToSuiteRoot(): void {
    //window.open(window.location.origin + '/suite/modules/app.html', '_self');
    window.open(window.location.origin + '/suite-new/home', '_self');
  }

  public static goToSuiteLogin(): void {
    window.open(window.location.origin + '/suite-new/login', '_self');
  }

  public static goToWhatsApp(): void {
    window.open('https://wa.me/5547988610826?text=Gostaria%20de%20conhecer%20os%20planos%20do%20S-Sign', '_blanck');
  }

  public static goToKnowledgeBase(): void {
    window.open('https://docs.satelitti.com.br/knowledge-base/entenda-os-tipos-de-assinatura-do-s-sign/', '_blanck');
  }

  public static getExecutionEnvironment(): ExecutionEnvironment {
    if (location.hostname === '127.0.0.1' || location.hostname == 'localhost') {
      return ExecutionEnvironment.localhost;
    }

    const urlPart = location.hostname.split('.')[1];
    switch (urlPart) {
      case ExecutionEnvironment.development:
        return ExecutionEnvironment.development;
      case ExecutionEnvironment.homologation:
        return ExecutionEnvironment.homologation;
      case 'satelitti':
        return ExecutionEnvironment.production;
      default:
        throw new Error(
          `Não foi possível obter o ambiente de execução a partir da parte da URL '${urlPart}'`
        );
    }
  }
}